import Backbone from 'backbone';

export default Backbone.Model.extend({
  constructor(attrs, options = {}) {
    Backbone.Model.apply(this, [attrs, { ...options, parse: true }]);
  },

  update(attributes, options) {
    let saveAttrs = {};
    if (this.rootKey) {
      saveAttrs[this.rootKey] = attributes;
      if (this.get('mode')) {
        saveAttrs.mode = this.get('mode');
      }
    } else {
      saveAttrs = attributes;

      const mode = this.get('mode');
      if (!saveAttrs.mode && mode) {
        saveAttrs.mode = mode;
      }
    }

    return this.save(null, {
      attrs: saveAttrs,
      wait: true,
      patch: true,
      success: options.success,
      error: options.error,
    });
  },

  toJSON() {
    const attrs = { ...this.attributes };
    let out;
    if (this.rootKey) {
      out = {};
      out[this.rootKey] = attrs;
      if (attrs.mode) {
        out.mode = attrs.mode;
      }
    } else {
      out = attrs;
    }

    return out;
  },
});




// WEBPACK FOOTER //
// ./app/models/base.js